export const environment = {
  production: true,
    serverUrl: 'https://admin.theoriecoach.nl',
    redirectUrl: 'https://theoriecoach.nl',
};
